import { Combobox } from "@ttc3k/trekker";
import { ComponentProps } from "react";
import { useController, useFormContext } from "react-hook-form";

type ControlledComboboxRootProps = ComponentProps<typeof Combobox.Root> & {
  name: string;
  forceInvalid?: boolean;
};

export const ControlledComboboxRoot = ({
  name,
  hint,
  forceInvalid = false,
  ...rest
}: ControlledComboboxRootProps) => {
  const { register, control } = useFormContext();
  const { fieldState } = useController({ name, control });
  const isInvalid = !!fieldState.error || forceInvalid;

  const props = {
    ...rest,
    ...register(name),
    hint: fieldState.error?.message ?? hint,
    ...(isInvalid
      ? { invalid: true, "data-invalid": true, "aria-invalid": true }
      : {}),
  };

  return <Combobox.Root {...props} />;
};
